import React from 'react';
import { Gift, Smartphone, Percent, Check, Star } from 'lucide-react';
import { tarifs } from '../data/mock';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';

const Tarifs = () => {
  return (
    <section id="tarifs" className="section-padding bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#006633]/5 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative">
        {/* Header */}
        <AnimateOnScroll animation="fadeUp">
          <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
            <div className="inline-flex items-center gap-2 bg-[#9B1B30]/10 text-[#9B1B30] px-4 py-2 rounded-full text-sm font-bold mb-6">
              <Star size={16} />
              <span>Tarifs transparents</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-6">
              Des prix clairs, <span className="gradient-text">sans surprise</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Lessive et adoucissant <strong className="text-[#9B1B30]">OFFERTS</strong> à chaque lavage.
            </p>
          </div>
        </AnimateOnScroll>

        {/* Free banner */}
        <AnimateOnScroll animation="scale">
          <div className="mb-12 bg-gradient-to-r from-[#006633] to-[#008844] rounded-3xl p-6 md:p-8 shadow-xl">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
                  <Gift className="w-8 h-8 text-white" />
                </div>
                <div className="text-white text-center md:text-left">
                  <h3 className="text-xl md:text-2xl font-bold">Lessive & Adoucissant OFFERTS</h3>
                  <p className="text-white/80">{tarifs.mention}</p>
                </div>
              </div>
              <div className="bg-white text-[#006633] px-8 py-4 rounded-2xl font-black text-3xl shadow-lg">
                0€
              </div>
            </div>
          </div>
        </AnimateOnScroll>

        {/* Pricing cards */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Lavage */}
          <AnimateOnScroll animation="fadeLeft">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl overflow-hidden shadow-2xl h-full">
              <div className="p-8">
                <div className="flex items-center gap-4 mb-8">
                  <span className="text-5xl">🧺</span>
                  <div>
                    <h3 className="text-2xl font-black text-white">Machine à laver</h3>
                    <p className="text-[#9B1B30] font-semibold">Lessive & Adoucissant OFFERTS</p>
                  </div>
                </div>
                
                <div className="space-y-4">
                  {tarifs.lavage.map((item, i) => (
                    <div 
                      key={i}
                      className="bg-white/5 rounded-2xl p-6 border border-white/10 hover:border-[#9B1B30]/50 transition-all hover:bg-white/10"
                    >
                      <div className="flex justify-between items-center mb-3">
                        <div>
                          <p className="text-gray-400 text-sm mb-1">Machine à laver</p>
                          <p className="text-3xl font-black text-white">{item.capacity}</p>
                        </div>
                        <p className="text-4xl font-black text-[#9B1B30]">{item.price}</p>
                      </div>
                      <div className="flex items-center gap-2 text-[#90EE90] text-sm">
                        <Check size={16} />
                        <span>Lessive & Adoucissant OFFERTS</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </AnimateOnScroll>

          {/* Séchage */}
          <AnimateOnScroll animation="fadeRight">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden border border-gray-100 shadow-xl h-full">
              <div className="p-8">
                <div className="flex items-center gap-4 mb-8">
                  <span className="text-5xl">💨</span>
                  <div>
                    <h3 className="text-2xl font-black text-gray-900">Séchoir</h3>
                    <p className="text-gray-500">Séchage rapide et efficace</p>
                  </div>
                </div>
                
                <div className="space-y-4">
                  {tarifs.sechage.map((item, i) => (
                    <div 
                      key={i}
                      className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100"
                    >
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="text-gray-500 text-sm mb-1">Séchoir</p>
                          <p className="text-3xl font-bold text-gray-900">{item.capacity}</p>
                        </div>
                        <p className="text-4xl font-black text-[#006633]">{item.price}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Payment info */}
                <div className="mt-6 bg-gray-900 rounded-2xl p-5 text-white">
                  <p className="font-bold mb-2">Moyens de paiement</p>
                  <div className="flex gap-3">
                    <span className="bg-white/10 px-3 py-1.5 rounded-lg text-sm">💶 Espèces</span>
                    <span className="bg-white/10 px-3 py-1.5 rounded-lg text-sm">💳 CB / Sans contact</span>
                  </div>
                </div>
              </div>
            </div>
          </AnimateOnScroll>
        </div>

        {/* App discount */}
        <AnimateOnScroll animation="fadeUp">
          <div className="bg-gradient-to-br from-[#9B1B30] to-[#7A1526] rounded-3xl p-8 md:p-10 relative overflow-hidden shadow-2xl">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-black/10 rounded-full blur-3xl" />
            
            <div className="relative flex flex-col lg:flex-row items-center gap-8">
              <div className="w-20 h-20 bg-white/20 rounded-3xl flex items-center justify-center flex-shrink-0">
                <Smartphone className="w-10 h-10 text-white" />
              </div>
              
              <div className="flex-1 text-center lg:text-left">
                <h4 className="text-2xl md:text-3xl font-black text-white mb-2">
                  Économisez avec l'application fidélité
                </h4>
                <p className="text-white/80 text-lg">
                  Scannez le QR code à la borne, rechargez vos crédits et profitez de réductions exclusives.
                </p>
              </div>
              
              <div className="bg-white text-[#9B1B30] px-8 py-5 rounded-2xl text-center flex-shrink-0 shadow-xl">
                <p className="text-sm font-medium text-gray-600">Jusqu'à</p>
                <p className="text-5xl font-black">-10%</p>
              </div>
            </div>
          </div>
        </AnimateOnScroll>

        {/* Pro rates */}
        <AnimateOnScroll animation="fadeUp">
          <div className="mt-12 text-center">
            <div className="inline-flex items-center gap-3 bg-gray-100 px-6 py-4 rounded-full shadow-md">
              <Percent className="w-6 h-6 text-[#9B1B30]" />
              <span className="font-bold text-gray-900 text-lg">
                Professionnels : jusqu'à <span className="text-[#9B1B30]">-30%</span> selon volume
              </span>
            </div>
            <p className="text-gray-500 mt-4">
              <a href="#marches" className="text-[#9B1B30] hover:underline font-semibold">
                Découvrez nos offres par secteur →
              </a>
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default Tarifs;
